export default "__VITE_ASSET__CkkLF7jj__"